module.exports = __webpack_public_path__ + "img/partner-3.061dde1b.png";